var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / LB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-LB",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#F03340",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#F03340",
    mask: "url(#mask-2)",
    x: 0,
    y: 14.6666667,
    width: 28,
    height: 5.33333333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.866998,12.4663353 C13.1245479,12.2087854 13.1223958,11.7890624 12.8630829,11.5297495 L13.1369171,11.8035837 C12.877205,11.5438716 12.3812866,11.4046783 12.0211411,11.4947147 L10.6455256,11.8386185 C10.2890117,11.927747 10.2460938,11.8154296 10.5396398,11.5952701 L12.1270269,10.4047298 C12.4250617,10.1812037 12.3715598,9.99999994 12.0006956,9.99999994 L11.3326377,9.99999994 C10.9648321,9.99999994 10.932106,9.86728026 11.2584864,9.70409006 L12.7415136,8.96257649 C13.0683666,8.79914997 13.0382264,8.66666661 12.6673623,8.66666661 L11.9993044,8.66666661 C11.6314987,8.66666661 11.5794271,8.48209629 11.8729731,8.26193676 L13.4603602,7.07139645 C13.758395,6.84787033 14.2460938,6.85123692 14.5396398,7.07139645 L16.1270269,8.26193676 C16.4250617,8.48546288 16.3715598,8.66666661 16.0006956,8.66666661 L15.3326377,8.66666661 C14.9648321,8.66666661 14.932106,8.79938628 15.2584864,8.96257649 L16.7415136,9.70409006 C17.0683666,9.86751657 17.0382264,9.99999994 16.6673623,9.99999994 L15.9993044,9.99999994 C15.6314987,9.99999994 15.5794271,10.1845703 15.8729731,10.4047298 L17.4603602,11.5952701 C17.758395,11.8187962 17.71462,11.9286549 17.3544744,11.8386185 L15.9788589,11.4947147 C15.622345,11.4055862 15.1223958,11.5442708 14.8630829,11.8035837 L15.1369171,11.5297495 C14.877205,11.7894616 14.875,12.2083333 15.133002,12.4663352 L15.5336647,12.866998 C15.7912146,13.1245478 15.6993499,13.3333333 15.3394814,13.3333333 L12.6605186,13.3333333 C12.2957243,13.3333333 12.2083333,13.125 12.4663353,12.866998 L12.866998,12.4663353 Z",
    id: "Rectangle-317",
    fill: "#1FC065",
    mask: "url(#mask-2)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLb);
export default __webpack_public_path__ + "static/media/LB.3308e03e3d565dfcfdb63056e9be55db.svg";
export { ForwardRef as ReactComponent };